import Cookies from 'universal-cookie';
const cookies = new Cookies();

export function getIsLoggedInCookies() {
  return cookies.get('isLoggedIn') === 'true';
}

export function getGaCookies() {
  return cookies.get('_ga') || ''
}
